// const speed = 300;
// const ease = $.bez([.45, .05, .19, 1]);
const templates = [
	{
		id: "wishlist-button",
		data: "product",
		events: {
			"click button[data-wk-add-product]": (event) => {
				event.preventDefault();
				event.stopPropagation();
				const variantInput = document.querySelector("form *[name='id']");
				const variantId = variantInput ? variantInput.value : undefined;
				WishlistKing.toolkit.addProduct(
					event.currentTarget.getAttribute("data-wk-add-product"),
					variantId
				);
				//Show popup when adding product to wishlist
				if(!$('body').hasClass('transition')){
					$('body').addClass('transition overlay')
					$('#popup-wishlist').toggle('slide', {
						direction: 'right',
						easing: ease,
						complete: function(){
							$('#popup-wishlist').find('.module-popup_content').fadeIn(speed*2, function(){
								$('body').removeClass('transition')
								$('#popup-wishlist').find('input').first().focus()
							})
						}
					}, speed*2);
				}
			},
			"click button[data-wk-remove-product]": (event) => {
				event.preventDefault();
				event.stopPropagation();
				WishlistKing.toolkit.removeProduct(
					event.currentTarget.getAttribute("data-wk-remove-product")
				);
			},
			"click button[data-wk-remove-item]": (event) => {
				event.preventDefault();
				event.stopPropagation();
				WishlistKing.toolkit.removeItem(
					event.currentTarget.getAttribute("data-wk-remove-item")
				);
			},
		},
		template: `
			{% if product.in_wishlist %}
				{% assign btn_text = locale.in_wishlist %}
				{% assign btn_title = locale.remove_from_wishlist %}
				{% assign btn_action = 'remove' %}
			{% else %}
				{% assign btn_text = locale.add_to_wishlist %}
				{% assign btn_title = locale.add_to_wishlist %}
				{% assign btn_action = 'add' %}
			{% endif %}

			{% assign scope = "product" %}
			{% assign targetId = product.id %}

			{% if itemId %}
				{% assign scope = "item" %}
				{% assign targetId = itemId %}
			{% endif %}

			<button
				type="button"
				class="wk-button wk-button--{{ btn_action }} {{ addClass }} group/wishlist"
				data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}"
				{% unless product.in_wishlist %}data-empty{% endunless %}>
			</button>
		 `,
	},
	{
		id: "wishlist-page",
		data: "wishlist",
		events: {
			"click a[data-wk-share]": (event) => {
				event.preventDefault();
				event.stopPropagation();

				WishlistKing.toolkit.requestWishlistSharing({
					wkShareService: event.currentTarget.getAttribute(
						"data-wk-share-service"
					),
					wkShare: event.currentTarget.getAttribute("data-wk-share"),
					wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
				});
			},
		},
		template: `

			{% if wishlist.item_count == 0 or customer == 'null' %}

				<!--Module Sections-->
				<div class="module-sections_footer">
					<div class="module-section_content">
						<p>
							{% if customer == null %}
								You need to register to access the wishlist.<br>
								<a href="/account/register">Create an account</a> or <a href="/account/login">sign in</a>.
							{% else %}
								Your wishlist is currently empty.<br>
								Go back to <a href="/collections/view-all">Shop</a>.
							{% endif %}
						</p>
					</div>
				</div>

			{% endif %}

			{% if wishlist.item_count > 0 and customer != 'null' %}

				<!--Module List Items-->
				<div class="module-list_items">

					{% assign products = wishlist.products | reverse %}
					{% for product in products %}

						<!--Item-->
						<div class="module-list_item">

							<!--Item Number-->
							<span class="module-list_item-num">
								<span>
									{% if forloop.index < 10 %}0{% endif %}{{ forloop.index }}
								</span>
							</span>

							<!--Item Thumbnail-->
							<div class="module-list_item-thumbnail">

								<!--Item Link-->
								<a href="{{ product.url }}"
									class="product-link product-thumbnail">
									<img
										class="thumb lazyload"
										src="{{ product | variant_img_url: '60x' }}"
										data-src="{{ product | variant_img_url }}"
										alt="HELIOT EMIL_{{ product.title }}">
								</a>

							</div>

							<!--Item infos-->
							<table class="module-list_item-title">
								<tbody>
									<tr>
										<td>
											<span>ITEM</span>
										</td>
										<td>
											{{ product.title }}
										</td>
									</tr>

									{% unless product.has_only_default_variant %}
									{% for option in product.options_with_values %}
									<tr>
										<td>
											{{ option.name | upcase }}
										</td>
										<td>
											{{ option.selected_value | downcase | handle | escape | capitalize | replace: 'One-size', 'OS' | replace: 'Os', 'OS' | replace: '-', '/' | replace: 'Xxs', 'XXS' | replace: 'Xs', 'XS' | replace: 'Xl', 'XL' | replace: 'Xxl', 'XXL' }}
										</td>
									</tr>
									{% endfor %}
									{% endunless %}

								</tbody>
							</table>

							{% assign variant = product.selected_or_first_available_variant %}

							<!--Item Totals-->
							<table class="module-list_item-totals">
								<tbody>
									<!--Item Quantity-->
									<tr>
										<td>STOCK</td>
										<td>
											{% assign stock = variant.inventory_quantity %}
											{% if stock > 1 %}
												{% if stock > 10 %}
													More than 10 available
												{% else %}
													Less than {{ stock | plus: 1 }} available
												{% endif %}
											{% else %}
												{% if stock < 1 %}
													Sold out
												{% else %}
													Only 1 in stock
												{% endif %}
											{% endif %}
										</td>
									</tr>
									<!--price-->
									<tr>
										<td>PRICE</td>
										<td>
											<span
												class="money"
												val="{{ variant.price | money }}">
												{{ variant.price | money }}
											</span>
										 </div>
										</td>
										{% if stock < 1 %}
										<td>
											{% include "wishlist-button" product: product %}
										</td>
										{% endif %}
									</tr>
									{% if stock > 0 %}
									<!--Actions-->
									<tr class="module-list_item-actions">
										<td></td>
										<td>
											<a href="/cart/add/{{ variant.id }}">ADD TO CART</a>
										</td>
										<td>
											{% include "wishlist-button" product: product %}
										</td>
									</tr>
									{% endif %}
								</tbody>
							</table>

						</div>

					{% endfor %}

				</div>

				{% assign actions = false %}
				{% for product in products %}
					{% if product.available %}
						{% assign variant = product.selected_or_first_available_variant %}
						{% if variant.available %}
							{% unless variant.requires_selling_plan %}
								{% assign actions = true %}
							{% endunless %}
						{% endif %}
					{% endif %}
				{% endfor %}

				{% if actions == true %}
					<!--Module Sections-->
					<div class="module-sections">
						<table>
							<tbody>
								<tr>
									<td>TOTAL</td>
									<td>
										{% assign total = 0 %}
										{% for product in products %}
											{% assign variant = product.selected_or_first_available_variant %}
											{% assign total = total | plus: variant.price %}
										{% endfor %}
										<span
											class="money"
											val="{{ total | money }}">
											{{ total | money }}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<!--Module CTA-->
					<form
						class="module-cta"
						action="/cart"
						method="post">

						{% for product in products %}
							{% if product.available %}
								{% assign variant = product.selected_or_first_available_variant %}
								{% if variant.available %}
									{% unless variant.requires_selling_plan %}
										<input
											type="hidden"
											name="updates[{{ variant.id }}]"
											value="1" />
									{% endunless %}
								{% endif %}
							{% endif %}
						{% endfor %}

						<button
							class="cta"
							type="submit"
							name="cart">
							ADD ALL TO CART
						</button>

					</form>
				{% endif %}

			{% endif %}
		`,
	},
];

export default templates;